/**
 * Types de la messagerie interne du ménage, partagés par l'app mobile et la page
 * web de la gouvernante (réponses de `/housekeeping/messaging/*`).
 */

export type BoiteMenage = 'gouvernance' | 'technique' | 'reception';
export type TypeFil = 'direct' | 'team' | 'inter_facility';

export const REPONSES_RAPIDES = [
    'need_linen',
    'need_products',
    'room_done',
    'guest_in_room',
    'problem',
    'on_my_way',
    'ok_seen',
    'need_help',
] as const;
export type ReponseRapide = (typeof REPONSES_RAPIDES)[number];

export interface PersonneMenage {
    id: number;
    firstname: string | null;
    lastname: string | null;
}

export interface MessageMenage {
    id: number;
    thread_id: number;
    author: PersonneMenage | null;
    is_mine: boolean;
    hidden: boolean;
    text: string | null;
    original: string | null;
    source_locale: string | null;
    translation_pending: boolean;
    translation_unavailable: boolean;
    quick_reply_key: ReponseRapide | null;
    audio_url: string | null;
    photo_url: string | null;
    room: { id: number; name: string } | null;
    is_urgent: boolean;
    /** « Masquer » et « Qui a lu » sont permis au lecteur (messages de son hôtel, gouvernance). */
    can_moderate: boolean;
    reply_to: { id: number; text: string | null } | null;
    read_by_me?: boolean;
    read_count?: number;
    created_at: string;
}

export interface FilMenage {
    id: number;
    kind: TypeFil;
    box: BoiteMenage | null;
    member?: PersonneMenage | null;
    team_date: string | null;
    counterpart?: { id: number; name: string } | null;
    read_only: boolean;
    last_message_at: string | null;
    unread_count: number;
    has_unread_urgent: boolean;
    last_message?: MessageMenage | null;
}

export interface ListeFilsMenage {
    threads: FilMenage[];
    can: {
        open_boxes: BoiteMenage[];
        team: boolean;
        urgent: boolean;
        inter_facilities: { id: number; name: string }[];
    };
    team_date: string;
    ceiling: { used: number; limit: number; reached: boolean } | null;
}

export interface PageMessages {
    data: MessageMenage[];
    has_more: boolean;
    can_write: boolean;
}

/** « Prénom Nom » d'une personne de la messagerie ; `repli` quand les deux manquent. */
export function nomPersonne(personne: { firstname?: string | null; lastname?: string | null } | null | undefined, repli = ''): string {
    return [personne?.firstname, personne?.lastname].filter(Boolean).join(' ') || repli;
}
